import getInstance from "../config/api";

export default class Consolidated {
  static async fetchSimulation(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/simulation", { params });
    return data;
  }

  static async fetchClient(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/client", { params });
    return data;
  }

  static async fetchAccess(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/access", { params });
    return data;
  }

  static async fetchContract(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/contract", { params });
    return data;
  }

  static async fetchHash(params) {
    const instance = getInstance();
    const { data } = await instance.get("/consolidated/hash", { params });
    return data;
  }

  static async fetchTotalContracts(bankId = "") {
    const instance = getInstance();
    const { data } = await instance.get(
      `/consolidated/totalContracts?bankId=${bankId}`
    );
    return data;
  }

  static async fetchInsuranceContracts(codCompany = "") {
    const instance = getInstance();
    const { data } = await instance.get(
      `/consolidated/totalContractsWithInsurance?codCompany=${codCompany}`
    );
    return data;
  }
}
